import React, { useState, useEffect, Fragment } from "react";
import { MdRemoveCircle } from "react-icons/md";
import { FaWindowClose } from "react-icons/fa";
import DropDown from "../Ui/DropDown";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import {
  createJob,
  getAllMasterProcess,
  getQuotation,
  corporateCompanyJobSaveAsDraft
} from "../../Redux/Actions/jobs";

import { getAllPaymentTypes } from "../../Redux/Actions/payment";
import LoadingButton from "../../utils/loadingButton";
import BasicTable from "../../utils/basicTable";
import { toastMessage } from "../../utils/toast";
import { Card, Modal, ModalBody, ModalFooter, ModalHeader, OverlayTrigger, Tooltip } from "react-bootstrap";
import './file.css'
import CONFIG from "../../config";
import { useTranslation } from "react-i18next";


let ID = 1;
const initialRequestJob = {
  id: ID,
  documentName: "",
  passportNo: "",
  document: [],
  documentNameIsFilled: false,
  documentIsFilled: false
};

function Create({ history }) {
  const [departmentId, setDepartmentID] = useState("");
  const [masterProcessId, setMasterProcessID] = useState("");
  const [processId, setProcessID] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [masterProcessList, setMasterProcessList] = useState([]);
  const [processList, setProcessList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [poNumber, setPoNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [requestJobLoading, setRequestJobLoading] = useState(false);
  const [saveAsDraftLoading, setSaveAsDraftLoading] = useState(false);
  const [showEmiratesIdBanner, setShowEmiratesIdBanner] = useState(false);
  const { t } = useTranslation();
  
  const [quotation, setQuotation] = useState({
    data: null,
    headers: [],
    rows: [],
  });
  const [requestJob, setRequestJob] = useState({
    isRequestJob: false,
    data: [initialRequestJob],
    id: 1,
  });

  const [departmentIdFlag, setDepartmentIdFlag] = useState(false);
  const [masterProcessIdFlag, setMasterProcessIdFlag] = useState(false);
  const [processIdFlag, setProcessIdFlag] = useState(false);
  const [poNumberFlag, setPoNumberFlag] = useState(false);
  const [paymentType, setPaymentType] = useState(1);
  const [selectedPaymentTypeOption, setSelectedPaymentTypeOption] = useState('');
  const [paymentTypeOptions, setPaymentTypeOptions] = useState({});
  const [validationError,setValidationError]=useState('');
  useEffect(() => {
    getMasterProcessApi();
    getAllPaymentTypesApi();
  }, []);

  useEffect(() => {
    if (quotation.data != null) {
      setQuotation((preState) => ({
        ...preState,
        headers: Object.keys(quotation.data),
        rows: [quotation.data],
      }));
    }
  }, [quotation.data]);

  const handleList = (key, ID) => {
    let list = [];
    if (key === "department") {
      list = departmentList.filter(({ value }) => value === ID)[0]
        .masterProcess;
      list = list.map(({ name, id, process }) => ({
        label: name,
        value: id,
        process: process,
      }));
      list.unshift({ label: "Select Department", value: 0, process: [] });
      setMasterProcessList(list);
      setProcessList([]);
      setMasterProcessID("");
      setProcessID("");
    } else {
      list = masterProcessList.filter(({ value }) => value === ID)[0].process;
      list = list.map(({ name, id }) => ({ label: name, value: id }));
      list.unshift({ label: "Select Master process", value: 0 });
      setProcessList(list);
    }
  };

  const getMasterProcessApi = async () => {
    try {
      const res = await apiWrapWithErrorWithData(getAllMasterProcess());
      const { data } = res.data;
      let departmentsList = Array.isArray(data?.department) ? data.department : [];
      departmentsList = departmentsList.map(({ name, id, masterProcess }) => ({
        label: name,
        value: id,
        masterProcess: masterProcess,
      }));
      departmentsList.unshift({
        label: "Select Department",
        value: 0,
        masterProcess: [],
      });
      setDepartmentList(departmentsList || []);
    } catch (error) {
      console.log("getMasterProcessApi", error)
    }
  };

  //Get payment types
  const getAllPaymentTypesApi = async () => {
    try {
      const res = await apiWrapWithErrorWithData(getAllPaymentTypes());
      const { data } = res.data;
      setPaymentTypeOptions((data || []).filter(option => option.value === 1 || option.value === 3));
    } catch (error) {
      console.log("getMasterProcessApi", error)
    }
  };
  const setFlag = () => {
    setDepartmentIdFlag(false)
    setMasterProcessIdFlag(false)
    setProcessIdFlag(false)
    setPoNumberFlag(false)
  }
  const handleSubmit = async () => {
    setIsLoading(true);
    let flag = false;
    setFlag()
    if (departmentId.label === undefined) {
      setDepartmentIdFlag(true)
      flag = true
    }
    if (masterProcessId.label === undefined) {
      setMasterProcessIdFlag(true)
      flag = true
    }
    if (processId.label === undefined) {
      setProcessIdFlag(true)
      flag = true
    }
    if (poNumber === '') {
      setPoNumberFlag(true)
      flag = true
    }
    if (flag) {
      setIsLoading(false);
      return;
    }
    setFlag()
    const payload = {
      departmentId: departmentId?.value,
      masterProcessId: masterProcessId?.value,
      processId: processId?.value,
      jobCount: requestJob.data.length,
      poNumber: poNumber
    };
    try {
      const res = await apiWrapWithErrorWithData(getQuotation(payload));
      const response = res.data;
      if (response.data) {
        setQuotation((preState) => ({ ...preState, data: response?.data }));
        setRequestJob((preState) => ({ ...preState, isRequestJob: true }))
      }
    } catch (error) {
      console.log("handleSubmitCreateQuotation", error);
    }
    setIsLoading(false);
    setShowModal(true);
  };

  const onChange = (index) => (event) => {
    setRequestJob((preState) => ({
      ...preState,
      data: [
        ...preState.data.slice(0, index),
        {
          ...preState.data[index],
          [event.target.name]:
            event.target.name === "document"
              ? event.target.files[0]
              : event.target.value,
        },
        ...preState.data.slice(index + 1),
      ],
    }));
  };

  const changeRequestJob = (index, name, flag) => {
    setRequestJob((preState) => ({
      ...preState,
      data: [
        ...preState.data.slice(0, index),
        {
          ...preState.data[index],
          [name]: flag
        },
        ...preState.data.slice(index + 1),
      ],
    }));
  };

  const handleFileChange = (index, event) => {
    const files = event.target.files;
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/x-zip-compressed', 'application/x-compressed'];
    const filteredFiles = Array.from(files).filter(file => allowedFormats.includes(file.type));

    if (filteredFiles.length !== files.length) {
      toastMessage("error", 'Invalid file format. Please select only jpg, jpeg, png, pdf, or zip files.');
      event.target.value = '';
      return;
    }

    if (filteredFiles.length > 15) {
      toastMessage("error", 'Please select less than 15 files.');
      event.target.value = '';
      return;
    }

    setRequestJob((prevState) => {
      const newData = [...prevState.data];
      const existingFiles = newData[index].document || [];

      if (existingFiles.length + filteredFiles.length > 15) {
        toastMessage("error", 'Total number of files should be less than 15.');
        event.target.value = '';
        return prevState;
      }

      newData[index].document = existingFiles.concat(filteredFiles);
      return { ...prevState, data: newData };
    });
  };

  const handleFileDelete = (fileIndex, documentIndex) => {
    setRequestJob((prevState) => {
      const newData = [...prevState.data];
      newData[documentIndex].document = newData[documentIndex].document.filter((_, index) => index !== fileIndex) || [];
      return { ...prevState, data: newData };
    });
  };

  // const onAddHandler = () => {
  //   let local = []
  //   let count = 1;
  //   const sliceEndIndex = Math.min(jobCount, requestJob.data.length);
  //   requestJob.data.slice(0, sliceEndIndex).forEach((data, i) => {
  //     const newData = { ...initialRequestJob, id: data.id, documentName: data.documentName, document: data.document };
  //     local.push(newData);
  //     count += 1;
  //   });
  //   for (let i = count; i <= jobCount; i++) {
  //     const newData = { ...initialRequestJob, id: i }
  //     local.push(newData)
  //   }
  //   setRequestJob((preState) => ({ ...preState, data: local }));
  // };

  // const onRemoveHandler = (index) => {
  //   setRequestJob((preState) => ({
  //     ...preState,
  //     data: [...requestJob.data.filter((_, i) => index !== i)],
  //   }));
  // };
  const onAddHandler = () => {
    setRequestJob((preState) => {
      if (preState.data.length >= 30) {
        toastMessage("error", "Maximum 30 rows allowed.");
        return preState;
      }
      return {
        ...preState,
        data: [
          ...preState.data,
          { ...initialRequestJob, id: preState.data.length + 1, documentName: '', document: [] }
        ],
      };
    });
  };

  const onRemoveHandler = (index) => {
    setRequestJob((preState) => ({
      ...preState,
      data: preState.data.filter((_, i) => i !== index),
    }));
  };

  const handleRequestJob = async () => {
    setRequestJobLoading(true);
    try {
      const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
      const [formId] = processes?.process.filter(pro => pro.id === parseInt(processId?.value, 10));
      const formData = new FormData();
      formData.append("DepartmentId", departmentId?.value);
      formData.append("MasterProcessId", masterProcessId?.value);
      formData.append("ProcessId", processId?.value);
      formData.append("FormId", formId?.formId);
      formData.append("JobCount", requestJob.data.length);
      formData.append("poNumber", poNumber);
      formData.append("PaymentType", paymentType);
      var i = 0;
      requestJob.data.forEach(({ document, documentName }, index) => {
        changeRequestJob(index, "documentNameIsFilled", false)
        changeRequestJob(index, "documentIsFilled", false)
      });
      let isFilled = false
      requestJob.data.forEach(({ document, documentName, passportNo }, index) => {
        if (documentName === '') {
          isFilled = true;
          changeRequestJob(index, "documentNameIsFilled", true)
        }
        let isFileFilled = true
        document.forEach((file, fileIndex) => {
          formData.append(`DocumentName[${i}]`, documentName);
          formData.append(`PassportNo[${i}]`, passportNo || "");
          formData.append(`Documents`, file);
          isFileFilled = false;
          i++;
        });
        if (isFileFilled) {
          isFilled = true;
          changeRequestJob(index, "documentIsFilled", true)
        }
      });
      if (isFilled) {
        setRequestJobLoading(false);
        return
      }
      const res = await apiWrapWithErrorWithData(createJob(formData));
    
      if (res.status === 400) {
        let errorMsg=res?.data?.message?res.data.message:res.Message;
        toastMessage("error", errorMsg);
      } else if (res?.Message !='' && res?.StackTraceString !=null) {
        let errorMsg=res?.data?.message?res.data.message:res.Message;
        setValidationError(errorMsg);
        toastMessage("error", errorMsg);
      }else if (res.status == 200 && res.data.data.isOnlinePayment && paymentType === 1) {
        toastMessage("success", res.data.message);
        history.push(`/checkout/${res.data.data.id}`)
      } else {
        const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? "File too large. Please upload smaller files." : "An error occurred");
        toastMessage("error", errorMsg);
        setShowModal(false);
        //history.push(`/jobs`)
      }
    } catch (error) {
      console.log("handleRequestJob:", error);
    }
    setRequestJobLoading(false);
  };

  const handleSaveAsDraft = async () => {
    setSaveAsDraftLoading(true);
    try {
      const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
      const [formId] = processes?.process.filter(pro => pro.id === parseInt(processId?.value, 10));
      const formData = new FormData();
      formData.append("DepartmentId", departmentId?.value);
      formData.append("MasterProcessId", masterProcessId?.value);
      formData.append("ProcessId", processId?.value);
      formData.append("FormId", formId?.formId);
      formData.append("JobCount", requestJob.data.length);
      formData.append("poNumber", poNumber);
      formData.append("PaymentType", paymentType);
      var i = 0;
      requestJob.data.forEach(({ document, documentName }, index) => {
        changeRequestJob(index, "documentNameIsFilled", false)
        changeRequestJob(index, "documentIsFilled", false)
      });
      let isFilled = false
      requestJob.data.forEach(({ document, documentName, passportNo }, index) => {
        if (documentName === '') {
          isFilled = true;
          changeRequestJob(index, "documentNameIsFilled", true)
        }
        let isFileFilled = true
        document.forEach((file, fileIndex) => {
          formData.append(`DocumentName[${i}]`, documentName);
          formData.append(`PassportNo[${i}]`, passportNo || "");
          formData.append(`Documents`, file);
          isFileFilled = false;
          i++;
        });
        if (isFileFilled) {
          isFilled = true;
          changeRequestJob(index, "documentIsFilled", true)
        }
      });
      if (isFilled) {
        setRequestJobLoading(false);
        return
      }
      const res = await apiWrapWithErrorWithData(corporateCompanyJobSaveAsDraft(formData));
      if (res.status === 400) {
        toastMessage("error", res.data.message);
      } else if (res.status == 200 && res.data.data.isOnlinePayment && paymentType === 1) {
        toastMessage("success", res.data.message);
        history.push(`/checkout/${res.data.data.id}`)
      } else if (res.data.message === 'Job saved successfully.' || res.data.message === 'Job saved successfully') {
        toastMessage("success", res.data.message);
        history.push(`/jobs`)
      } else {
        const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? "File too large. Please upload smaller files." : "An error occurred");
        toastMessage("error", errorMsg);
        setShowModal(false);
        //history.push(`/jobs`)
      }
    } catch (error) {
      console.log("handleRequestJob:", error);
    }
    setSaveAsDraftLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Please fill all required details
    </Tooltip>
  );

  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  const disableProceedButton = requestJob.data.some((row) => !row.documentName || row.document.length === 0);
 // Track expanded state for each row
 const [expandedRows, setExpandedRows] = useState({});
 const [docsLimit] = useState(1);
 // Toggle expanded/collapsed state for a row
 const toggleExpand = (rowIndex) => {
   setExpandedRows((prevState) => ({
     ...prevState,
     [rowIndex]: !prevState[rowIndex],
   }));
 };
 const handleDepartmentChange = (value) => {
  setProcessList([]);
  handleList("department", value.value);
  setDepartmentID(value);
 };
  return (
    <Fragment>
      <div className="d-flex">
        <div className="me-3" style={{ width: "100%" }}>
          <DropDown
            isSearchable={true}
            label={t("eidBasmati.department")}
            placeholder={t("eidBasmati.selectDepartment")}
            options={departmentList}
            value={departmentId}
            onChange={(value) => {
              setProcessList([]);
              handleList("department", value.value);
              setDepartmentID(value);
              handleDepartmentChange(value);
            }}
          />
          {departmentIdFlag ? <span style={{ color: 'red' }}>Department is requied</span> : null}
        </div>
        <div className="me-3" style={{ width: "100%" }}>
          <DropDown
            isSearchable={true}
            label={t("eidBasmati.masterProcess")}
            placeholder={t("eidBasmati.selectMasterProcess")}
            options={masterProcessList}
            value={masterProcessId}
            onChange={(value) => {
              handleList("masterProcess", value.value);
              setMasterProcessID(value);
            }}
          />
          {masterProcessIdFlag ? <span style={{ color: 'red' }}>Master process is requied</span> : null}
        </div>
        <div className="me-3" style={{ width: "100%" }}>
          <DropDown
            isSearchable={true}
            label={t("eidBasmati.process")}
            placeholder={t("eidBasmati.selectProcess")}
            options={processList}
            value={processId}
            onChange={(value) => {
              setProcessID(value);
              if(CONFIG.jobDepartmentID && value.value==CONFIG.jobDepartmentID){
                setShowEmiratesIdBanner(true);
              }else{
                setShowEmiratesIdBanner(false);
              }
            }}
          />
          {processIdFlag ? <span style={{ color: 'red' }}>Process is requied</span> : null}
        </div>
      </div>
      <div className="d-flex">
        <div className="me-3" style={{ width: "32%" }}>
          <label
            className="form-label col-md-4 col-sm-2"
            style={{ marginTop: "5px" }}
          >
            {t("eidBasmati.poNumber")}
          </label>
          <input
            className="p-1 form-control col-md-4 col-sm-2"
            type="text"
            onChange={(e) => setPoNumber(e.target.value)}
            value={poNumber}
            placeholder={t("eidBasmati.pleaseEnterPoNumber")}
          />
          {poNumberFlag ? <span style={{ color: 'red' }}>{t('eidBasmati.poNumberRequired')}</span> : null}
        </div>
      </div>
      <div className="row mt-4">
        <div className="d-flex gap-3 col-md-12">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onAddHandler}
          >
            {t("eidBasmati.addRow")}
          </button>
          <div className="d-flex gap-3">
            <h5>{t('eidBasmati.dataCount')} : </h5>
            <h5>{requestJob.data.length}</h5>
          </div>
        </div>
        {showEmiratesIdBanner && (
        <div className="alert alert-warning d-flex align-items-center justify-content-between" style={{ fontSize: '1.1rem', borderRadius: 8, marginBottom: 20, padding: 15, marginTop: 20 }}> 
          <span className="">
            <b>Warning:</b> Eid Basmati jobs must be created from the Eid-Basmati Create page. <a href="/job-eid-basmati-create" className="fw-bold text-decoration-underline">Go to Eid-Basmati Create Page</a>
          </span>
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={() => setShowEmiratesIdBanner(false)}>&times;</button>
        </div>
      )}
      {!showEmiratesIdBanner && (
        <>
        <Card border="light" className="w-95 scrollable-card">
      {requestJob.data.map((job, index) => (
        <div key={job.id} className="d-flex row mt-4">
          <div className="col-md-1 text-center mt-3">
            <h6>{index + 1}</h6>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor={`documentName-${job.id}`}> {t("eidBasmati.documentName")} </label>
              <input
                id={`documentName-${job.id}`}
                name="documentName"
                type="text"
                className="form-control"
                value={job.documentName}
                onChange={onChange(index)}
              />
              {job.documentNameIsFilled && (
                <span style={{ color: 'red' }}>Document name is required</span>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label htmlFor={`passportNo-${job.id}`}>{t("eidBasmati.passportNo")}</label>
              <input
                id={`passportNo-${job.id}`}
                name="passportNo"
                type="text"
                className="form-control"
                value={job.passportNo || ''}
                onChange={onChange(index)}
                placeholder={t("eidBasmati.enterPassportNo")}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label htmlFor={`document-${job.id}`}> {t("eidBasmati.uploadDocument")} </label>
              <div className="file-card">
                <div className="card-body">
                  <div className="kb-data-box">
                    <div className="kb-file-upload">
                      <div className="file-upload-box">
                        <input
                          name="document"
                          type="file"
                          id={`document-${job.id}`}
                          className="file-upload-input"
                          onChange={(e) => handleFileChange(index, e)}
                          multiple
                        />
                        <span>
                          Drag and drop or{' '}
                          <span className="file-link">Choose your files</span>
                        </span>
                      </div>
                    </div>
                    <div className="kb-attach-box">
                      {job.document
                        .slice(0, expandedRows[index] ? job.document.length : docsLimit)
                        .map((file, fileIndex) => {
                          const { name, lastModifiedDate, size } = file;
                          return (
                            <div
                              className="d-flex align-items-center justify-content-between file-atc-box"
                              key={fileIndex + name}
                              style={{
                                borderBottom: '1px solid #ddd',
                                padding: '5px 0',
                              }}
                            >
                               <button
                                type="button"
                                className="file-action-btn btn btn-sm btn-outline-danger"
                                onClick={() => handleFileDelete(fileIndex, index)}
                              >
                                Delete
                              </button>
                              <div className="file-detail d-flex align-items-center">
                                <span style={{ fontWeight: 'bold', marginRight: '10px' }}>
                                  {name}
                                </span>
                                <span style={{ fontSize: '0.9em', marginRight: '10px' }}>
                                  Size: {filesizes(size)}
                                </span>
                               
                              </div>
                             
                            </div>
                          );
                        })}
                      {job.document.length > docsLimit && (
                        <button
                          type="button"
                          className="btn btn-link"
                          onClick={() => toggleExpand(index)}
                        >
                          {expandedRows[index]
                            ? 'Show Less'
                            : `+${job.document.length - docsLimit} More`}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {job.documentIsFilled && (
                <span style={{ color: 'red' }}>Document is required</span>
              )}
            </div>
          </div>
          <div className="col-md-1 d-flex align-items-center justify-content-center">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => onRemoveHandler(index)}
              disabled={requestJob.data.length === 1}
            >
              <MdRemoveCircle size={22} />
            </button>
          </div>
        </div>
      ))}
    </Card>
        </>
      )}

        <div className="d-flex justify-content-end">
          <div className="d-flex justify-content-end m-3">
            {disableProceedButton ? (
              <OverlayTrigger overlay={renderTooltip}>
                <span className="d-inline-block">
                  <button className="btn btn-primary" onClick={handleSubmit} disabled={disableProceedButton}>
                    {t("eidBasmati.proceed")}
                  </button>
                </span>
              </OverlayTrigger>
            ) : (
              <button className="btn btn-primary" onClick={handleSubmit} disabled={disableProceedButton}>
                {t("eidBasmati.proceed")}
              </button>
            )}
          </div>
        </div>
      </div>

      <Modal show={showModal}>
        <ModalHeader>
          <Modal.Title>
            QUATATIONAL DETAILS
          </Modal.Title>
          <button className="btn btn-primary" onClick={handleCloseModal}><FaWindowClose /></button>
        </ModalHeader>
        <ModalBody>
          {quotation.headers.length ? (
            <div className="m-3" >
              <BasicTable headers={quotation.headers} data={quotation.rows} />
            </div>
          ) : null}
          <div>
          </div>
          <div className="w-100">
            <DropDown
              label={t("eidBasmati.selectPaymentType")}
              isSearchable={true}
              placeholder={"Online"}
              options={paymentTypeOptions}
              onChange={(value) => {
                setPaymentType(value.value);
              }}
            />
          </div>
          <p style={{ color: 'red' }}><b>{validationError}</b></p>
        </ModalBody>
        
        <ModalFooter>
          <div className="d-flex gap-3 justify-content-end">
              <LoadingButton
                isLoading={saveAsDraftLoading}
                onChange={handleSaveAsDraft}
              >
                {t('eidBasmati.saveAsDraft')}
              </LoadingButton>
              <LoadingButton
                isLoading={requestJobLoading}
                onChange={handleRequestJob}
              >
                {t('eidBasmati.requestJob')}
              </LoadingButton>
          </div>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default Create;
